import styled from "styled-components";
import { getBreakpoints } from "../../assets/store/cssBreakpoints";
const { xs, sm, md, lg, xl, xxl } = getBreakpoints();

export const MapSectionWrapper = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;
    font-family: inherit;
    margin: 0 auto;
    padding: 50px 0;
    background-image: url(${(props) =>
        props.backgroundImage
            ? props.backgroundImage
            : "https://fixedopsdigital.s3.amazonaws.com/development/TORQUE-MapRow-Background.jpg"});
`;

export const MapSectionInnerWrapper = styled.div`
    background: #ffffff;
    border-radius: 15px;
    max-width: 1400px;
    height: ${(props) => (props.directions ? "90%" : "fit-content")};
    margin: auto;
    padding: ${(props) => (props.directions ? null : "20px 0")};
    box-sizing: border-box;
    transition: max-height 2s ease-in-out, height 2s ease-in-out;

    @media only screen and (max-width: ${xxl}px) {
        width: 83%;
    }
`;

export const MapSectionHoursWrapper = styled.div`
    width: 90%;
    margin: 10px auto;
    padding: 10px 40px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    gap: 10px;

    @media only screen and (max-width: ${lg}px) {
        flex-direction: column;
    }

    @media only screen and (max-width: ${sm}px) {
        width: 100%;
        margin: 0 auto;
        padding: 10px;
    }
`;

export const HoursTitle = styled.div`
    grid-column: 1 / span 2;
    box-sizing: border-box;
    padding: 10px 0 10px 25px;
    font-weight: bolder;
    display: flex;
    align-items: center;
`;

export const HoursOutterWrapper = styled.div`
    background: #e9e9e9;
    display: grid;
    width: 50%;
    border-radius: ${(props) => props.borderRadius ?? '15px'};
    margin-left: 5px;
    font-size: 1em;
    line-height: unset;
    padding: 20px 0;
    gap: 0.5em;
    grid-template-columns: 40% 50%;
    flex: 1 0 0;

    @media only screen and (max-width: 1800px) {
        grid-template-columns: 35% 60%;
    }

    @media only screen and (max-width: ${lg}px) {
        margin-bottom: 10px;
        width: 100%;
        grid-template-columns: 50% 50%;
    }

    @media only screen and (max-width: ${sm}px) {
        width: 100%;
        margin-left: unset;
        font-size: 3vw;
        line-height: 1vh;
        padding: 5px 0;
    }
`;

export const HourColumnOne = styled.div`
    grid-column: 1;
    padding-left: 25px;
    padding-bottom: 10px;
    text-transform: ${(props) => props.textTransform ?? 'unset'};
`;

export const HourColumnTwo = styled.div`
    grid-column: 2;
    color: ${(props) => (props.closed ? "red" : "black")};
    text-transform: ${(props) => props.textTransform ?? 'uppercase'};
`;

export const InputWrapper = styled.div`
    &&& {
        width: 90%;
        padding: 10px 40px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        flex-direction: row;
        gap: 10px;

        input[type='text'] {
            height: unset !important;
            margin: unset !important;
        }
        @media only screen and (max-width: ${sm}px) {
            width: 100%;
            padding: 10px;
            flex-direction: column;
        }
    }
`;

export const DifferentAddressWrapper = styled.div`
    width: 100%;
    color: white;
    text-align: center;
    padding-top: 10px;
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;

    @media only screen and (max-width: ${sm}px) {
        font-size: 3vw;

    }
`;

export const MapFormInputField = styled.input`
    &&&&& {
        outline: none;
        border: none;
        background: #E9E9E9;
        box-sizing: border-box;
        max-width: unset;
    }
`;